import OCTreeView from './tree.component';

export default OCTreeView;



// WEBPACK FOOTER //
// ./index.js